module.exports = __webpack_public_path__ + "static/media/zerosuitsamus_0.0f12d983.png";